import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { normalizeError, translateError } from './errors';
import { toast } from './toast';

/**
 * Tratamento de erro GLOBAL.
 *
 * O `MutationCache.onError` é o que dá voz aos ~6 formulários que faziam
 * `await mutateAsync(...)` sem renderizar erro nenhum — um 402 de quota ou um 409 de
 * e-mail duplicado sumia em silêncio. Centralizar aqui evita repetir bloco de erro em
 * cada tela e faz códigos novos do backend aparecerem traduzidos sem tocar em UI.
 */
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (err, query) => {
      // `meta: { silent: true }` desliga o toast para queries de fundo.
      if (query.meta?.silent) return;

      const { status } = normalizeError(err);
      // 401 é fluxo normal: o apiFetch tenta refresh e, falhando, o AppLayout redireciona.
      if (status === 401) return;
      // Admin sem 2FA: o AppLayout troca a tela pela configuração; toast por query seria ruído.
      if (normalizeError(err).code === 'TWO_FACTOR_SETUP_REQUIRED') return;

      // Queries com refetchInterval (o sino, a cada 60s) gerariam um toast por ciclo
      // enquanto a API estivesse fora do ar. Só avisa na primeira falha.
      if (query.state.fetchFailureCount > 1) return;

      toast.error(translateError(err));
    },
  }),
  mutationCache: new MutationCache({
    onError: (err) => toast.error(translateError(err)),
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
